<template>
  <div class="_make-article">
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">สร้างOneChat Bot</h1>
    </header>
    <div class="MarkdownContent" style="width: 80%;">
      <p class="preindent">การสร้างBot สามารถเข้าไปสร้าง Bot ผ่านทางเว็บไซต์ของเรา หรือผ่านทาง API ก็ได้ </p> 
    </div>
    <header class="EndpointHeader">
      <h2 class="EndpointTitle">การสร้าง Bot ผ่านทางเว็บไซต์</h2>
    </header>
    <div class="hidden-sm-and-down">
      <p class="preindent">ลงชื่อเข้าใช้ระบบ หลังจากนั้นเลือกสร้างบอท</p>
      <h3>ภาพตัวอย่างการสร้าง bot</h3>
      <img src="../../assets/image/createbotweb.png" style="height: 60vh;" >
    </div>
    <div class="hidden-md-and-up">
      <p class="preindent">ลงชื่อเข้าใช้ระบบ หลังจากนั้นเลือกสร้างบอท</p>
      <v-layout align-center justify-center column wrap>
        <v-flex xs12 md12>
          <img src="../../assets/image/createbotmo.jpg" style="height: 80vh;" >
        </v-flex>
      </v-layout>
    </div>

    <header class="EndpointHeader">
      <h2 class="EndpointTitle">การสร้าง Bot ผ่านทาง API</h2>
      - 
      <span class="EndpointVerbPost">
        POST
      </span>
      <span class="EndpointUrl">
        {{urlcreatebot}}
      <v-icon class="urlcopy" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlcreatebot">file_copy</v-icon>
    </span>
    </header>
    <div class="MarkdownContent hidden-sm-and-down">
      <p class="preindent">ทุกครั้งที่ทำการติดต่อ API กับทางOneChat ต้องส่ง Authorization มาใน Header ทุกครั้ง </p>
      <h3>Header Parameter</h3>
      <!--  <v-btn type="button"
      v-clipboard:copy="message">Copy text</v-btn> -->
      <code class="codecolor" style="">
        <v-tooltip top >
          <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="headermessage">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Test.Authorization"</span>
  }
      </code>

      <h3>Request Parameter</h3>
      <!--  <v-btn type="button"
      v-clipboard:copy="message">Copy text</v-btn> -->
      <code class="codecolor" style="">
        <v-tooltip top >
          <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="requestmessage">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
    {
    <span class="colorkey">"token_owner"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"OneChatBot1"</span>,
    <span class="colorkey">"bot_name"</span> : <span class="colorvalue">"BotOneChat"</span>,
    <span class="colorkey">"detail"</span> : <span class="colorvalue">"Bot ที่สร้างขึ้นนี้มีวัตถุประสงค์เพื่อการทดลองศึกษา"</span>,
    <span class="colorkey">"webhook"</span> : <span class="colorvalue">"https://testwebhook.onechat.co.th"</span>,
    <span class="colorkey">"message_default"</span> : <span class="colorvalue">"สวัสดีค่ะ ขอบคุณที่Add ระบบBot ของเรา"</span>
    }
      </code>

      <h3>รายละเอียดข้อมูลที่ใช้ในการส่ง Request</h3>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็นต้องใช้ (required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>token_owner</td>
          <td>String</td>
          <td>required</td>
          <td>Token ของผู้ใช้ที่ต้องการสร้าง bot</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>required</td>
          <td>ID ของบอท เพื่อใช้ในการแอดบอท</td>
        </tr>
        <tr>
          <td>bot_name</td>
          <td>String</td>
          <td>required</td>
          <td>ชื่อของบอทที่ใช้ในการแสดง</td>
        </tr>
        <tr>
          <td>detail</td>
          <td>String</td>
          <td>X</td>
          <td>รายละเอียดและวัตถุประสงค์ของการสร้างบอท</td>
        </tr>
        <tr>
          <td>webhook</td>
          <td>String</td>
          <td>X</td>
          <td>เว็บไซต์ของผู้พัฒนา เพื่อรับและจัดการกับข้อความที่เข้าถึงบอท</td>
        </tr>
        <tr>
          <td>message_defult</td>
          <td>String</td>
          <td>X</td>
          <td>ข้อความต้อนรับ หลังจากเพิ่มบอทเป็นเพื่อน</td>
        </tr>
      </table>


      <h3>Response</h3>
          <code class="codecolor" style="">
        <v-tooltip top >
          <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="responsemessage">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
    {
    <span class="colorkey">"message"</span> : <span class="colorvalue">"create success"</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>,
    <span class="colorkey">"tokenBot"</span> : <span class="colorvalue">"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>
    }
      </code>
      <h3>รายละเอียดข้อมูลที่ได้จาก Response</h3>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ข้อความแสดงสถานะทั้งสำเร็จและไม่สำเร็จ</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>1. success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          2. fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>tokenBot</td>
          <td>String</td>
          <td>Token ของบอทที่ทำการสร้างขึ้น</td>
        </tr>
      </table>
    </div>
    <!-- mobile -->
    <div class="hidden-md-and-up">
      <p class="preindent">ทุกครั้งที่ทำการติดต่อ API กับทางOneChat ต้องส่ง Authorization มาใน Header ทุกครั้ง </p>
      <h3>Header Parameter</h3>
      <code class="codecolormo" style="">
        <v-tooltip top >
          <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="headermessage">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Test.Authorization"</span>
  }
      </code>

      <h3>Request Parameter</h3>
      <code class="codecolormo" style="">
        <v-tooltip top >
          <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="requestmessage">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
    {
    <span class="colorkey">"token_owner"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"OneChatBot1"</span>,
    <span class="colorkey">"bot_name"</span> : <span class="colorvalue">"BotOneChat"</span>,
    <span class="colorkey">"detail"</span> : <span class="colorvalue">"Bot ที่สร้างขึ้นนี้มีวัตถุประสงค์เพื่อการทดลองศึกษา"</span>,
    <span class="colorkey">"webhook"</span> : <span class="colorvalue">"https://testwebhook.onechat.co.th"</span>,
    <span class="colorkey">"message_default"</span> : <span class="colorvalue">"สวัสดีค่ะ ขอบคุณที่Add ระบบBot ของเรา"</span>
    }
      </code>

      <h3>รายละเอียดข้อมูลที่ใช้ในการส่ง Request</h3>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็นต้องใช้ (required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>token_owner</td>
          <td>String</td>
          <td>required</td>
          <td>Token ของผู้ใช้ที่ต้องการสร้าง bot</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>required</td>
          <td>ID ของบอท เพื่อใช้ในการแอดบอท</td>
        </tr>
        <tr>
          <td>bot_name</td>
          <td>String</td>
          <td>required</td>
          <td>ชื่อของบอทที่ใช้ในการแสดง</td>
        </tr>
        <tr>
          <td>detail</td>
          <td>String</td>
          <td>X</td>
          <td>รายละเอียดและวัตถุประสงค์ของการสร้างบอท</td>
        </tr>
        <tr>
          <td>webhook</td>
          <td>String</td>
          <td>X</td>
          <td>เว็บไซต์ของผู้พัฒนา เพื่อรับและจัดการกับข้อความที่เข้าถึงบอท</td>
        </tr>
        <tr>
          <td>message_defult</td>
          <td>String</td>
          <td>X</td>
          <td>ข้อความต้อนรับ หลังจากเพิ่มบอทเป็นเพื่อน</td>
        </tr>
      </table>


      <h3>Response</h3>
          <code class="codecolormo" style="">
        <v-tooltip top >
          <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="responsemessage">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
    {
    <span class="colorkey">"message"</span> : <span class="colorvalue">"create success"</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>,
    <span class="colorkey">"tokenBot"</span> : <span class="colorvalue">"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>
    }
      </code>
      <h3>รายละเอียดข้อมูลที่ได้จาก Response</h3>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ข้อความแสดงสถานะทั้งสำเร็จและไม่สำเร็จ</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>1. success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          2. fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>tokenBot</td>
          <td>String</td>
          <td>Token ของบอทที่ทำการสร้างขึ้น</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urlcreatebot: '',
    headermessage: '{\n\t"Authorization":"Test.Authorization"\n}',
    requestmessage: '{\n\t"token_owner": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"bot_id": "OneChatBot1",\n\t"bot_name": "BotOneChat",\n\t"detail": "Bot ที่สร้างขึ้นนี้มีวัตถุประสงค์เพื่อการทดลองศึกษา",\n\t"webhook": "https://testwebhook.onechat.co.th",\n\t"message_default": "สวัสดีค่ะ ขอบคุณที่Add ระบบBot ของเรา"\n}',
    responsemessage: '{\n\t"message": "create success",\n\t"status": "success",\n\t"tokenBot": "B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"\n}'
  }),
  created () {
    this.urlcreatebot = process.env.APImanage + '/api/createbot'
  }
}
</script>

<style type="text/css" scoped>
.preindent {
  text-indent: 2em;
  text-align: justify;
}

._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 90vw;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
    /*cursor: pointer;*/
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


/*.divbutton {
    height: 30px;
    background: #000;
}*/

.requestfile {
    display: none !important;
}

.codecolor:hover .requestfile {
    display: block !important;
}

.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.responsefile{
    display: none !important;
}

.codecolor:hover .responsefile {
    display: block !important;
}
#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/createbot.vue